import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, Sparkles, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useBooking } from '../contexts/BookingContext';
import { Button } from '../components/ui/button';
import { Dialog, DialogContent } from '../components/ui/dialog';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Category images
const CATEGORY_IMAGES = {
  lashes_brows: "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/ob6qvf2e_725b4c0a23e7e03d3266230433ac2aaa.jpg",
  makeup: "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/b0hf6kac_db09cf2493ab8e9fecc5235835f464b2.jpg",
  facial_care: "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/b16yvmz1_399db853fa16b84bc73cf9946edd3f1b.jpg",
  manicure: "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/oypc7kwy_bd040ad65cf80f8b6bcf91c93b53e989.jpg",
  pedicure: "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/hlu1yql0_542d990c9ac5fa9185bf11f8f8c82f56.jpg",
  waxing: "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/uw9d9mbx_345082826a2ad5f9090cb058008f789a.jpg",
};

// Hero image
const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/a3s9eaxh_59bc170b50dbe6633dd71b4c3d031d87.jpg";

const categoryLabels = {
  lashes_brows: { pt: 'Pestanas & Sobrancelhas', en: 'Lashes & Brows', fr: 'Cils & Sourcils', de: 'Wimpern & Augenbrauen', es: 'Pestañas & Cejas' },
  makeup: { pt: 'Maquilhagem', en: 'Makeup', fr: 'Maquillage', de: 'Make-up', es: 'Maquillaje' },
  facial_care: { pt: 'Cuidados Faciais', en: 'Facial Care', fr: 'Soins du Visage', de: 'Gesichtspflege', es: 'Cuidado Facial' },
  manicure: { pt: 'Manicure', en: 'Manicure', fr: 'Manucure', de: 'Maniküre', es: 'Manicura' },
  pedicure: { pt: 'Pedicure', en: 'Pedicure', fr: 'Pédicure', de: 'Pediküre', es: 'Pedicura' },
  waxing: { pt: 'Depilação', en: 'Waxing', fr: 'Épilation', de: 'Waxing', es: 'Depilación' },
};

// Detailed service descriptions
const SERVICE_DETAILS = {
  // MANICURE - Pretties Cutties Hands
  "mn1": {
    name: "Classic Manicure",
    duration: "40min",
    description: "Tailor-made hand care adapted to an urgent need for ECLAT to give a look as clean as the nail attractions."
  },
  "mn2": {
    name: "Nourished Hands",
    duration: "50min",
    description: "Hands Treatment indicated to solve skin drought problems, dehydration, stiffness through an exfoliation, a hydrating mask and massage sequences conducive to solving the various situations related to the joint system, and at the poor circulation of liquids."
  },
  "mn3": {
    name: "Nails Gel & Acrylic Extension",
    duration: "60min",
    description: "Laying Normal varnish on natural nails, Laying Gel varnish on natural nails, Nails Gel Extensions, Manutention of Gel nail extension, Removing Gel varnish, clean & shine nails."
  },
  // PEDICURE - Lighter and BeautiFeet
  "pd1": {
    name: "Soft Spa Pedicure",
    duration: "40min",
    description: "Cleansing foot recommended to provide a care as well express as lighten while aiming for an energetically booster foot feeling."
  },
  "pd2": {
    name: "Luxurious Holistic Foot",
    duration: "60min",
    description: "This specific care also called medical pedicure goes into depth treat while preventing various affections related to the feet through surgical nail cleaning, their embellishments. Intense exfoliation, a hyper moisturizing mask, a special heavy foot massage axed on points of plantar reflexology."
  },
  // LASHES & BROWS
  "lb1": {
    name: "Lashes Extensions",
    duration: "90min",
    description: "This service makes your gaze as appetizing as authentic... eyelashes extensions ranging from natural effect, passing through the doll effect until the cat effect... 7 types of volume available: hybrid, light, Egyptian, Indian, Brazilian, Mega Volume and Russian."
  },
  "lb2": {
    name: "Lashes Manutention",
    duration: "45min",
    description: "Maintenance session for your lashes extensions to keep them looking fresh and beautiful."
  },
  "lb3": {
    name: "Lashes Renovation",
    duration: "30min",
    description: "Removing lashes extensions safely and professionally."
  },
  "lb4": {
    name: "Lashes Lifting",
    duration: "50min",
    description: "This treatment is an eyelash enhancement that will leave them hydrated and very shiny, it will also accentuate their natural curves from the root upwards, making them strong, revitalized and structured. PS: eyelashes can be tinted at your request."
  },
  "lb5": {
    name: "HENNA Coloration",
    duration: "60min",
    description: "Coloring your eyebrows with a Bio-organic substance called Henna, perfect for all skin types, without any side effects, or allergens risks to highlight the depth of your look."
  },
  "lb7": {
    name: "Brow Lifting",
    duration: "60min",
    description: "Brow lifting treatment combined with Henna coloration for perfectly defined and colored eyebrows."
  },
  "lb9": {
    name: "Brow Design",
    duration: "30min",
    description: "In order to enhance your eye effect, and make it more attractive and less common... your eyebrow is highlighted here obedient to very square rules which will respect the shape of your face, the shape of your eyes and various features necessary for the design of your perfect eyebrow."
  },
  // MAKEUP
  "mk1": {
    name: "Natural Effect",
    duration: "40min",
    description: "Day makeup for a fresh, natural look that enhances your features subtly."
  },
  "mk2": {
    name: "Queen Goal / Party",
    duration: "60min",
    description: "Glamorous party makeup to make you shine in the dark and stand out at any event."
  },
  "mk3": {
    name: "Wedding Up",
    duration: "120min",
    description: "Complete bridal makeup service for your special day, ensuring you look radiant and picture-perfect."
  },
  // FACIAL CARE
  "fc1": {
    name: "Kamit Skin's Refresh",
    duration: "30min",
    description: "Treatment tailored to your skin's specific needs leaving it healthy and refreshed in just half hour. Express facial care."
  },
  "fc2": {
    name: "Smooth Calm Skin",
    duration: "60min",
    description: "Specific care adapted to sensitive, reactive and ultra-aggressive skin in need of pampering through our clinically and dermatologically tested and proven Bio-Organic products which will provide delicate and soothing attention while nourishing them."
  },
  "fc3": {
    name: "Moisturizing Derma Touch",
    duration: "60min",
    description: "This facial will provide extremely deep hydration to skin that suffers from dryness while reducing their irritation and tightness in order to offer them a healthy appearance on the surface as well as internally."
  },
  "fc4": {
    name: "Acne & Blemish Solutions",
    duration: "60min",
    description: "A revelation for oily congested or hormonal skin, this mattifying facial will help combat oil and shine while intuitive massage helps restore micro circulation. A deeply detoxifying treatment for clear and bright skin using powerful organic active ingredients aimed at combating any problem linked to pigmentary disorders."
  },
  "fc5": {
    name: "Facial Cell Renewal & Lift",
    duration: "75min",
    description: "Brightening Peel with the aim of reducing the signs of aging and tonality skin issues. This precision treatment uses layers of enzymes for powerful exfoliation and renewal - a new start for smoother, younger looking skin."
  },
  "fc6": {
    name: "Pro-Elastin & Collagen Boost",
    duration: "60min",
    description: "Powered by breakthrough technology, this facial helps restore the architecture of the face using potent nutrients in plant actives to boost our natural elastin and collagen using combination of lifting massage techniques for a profoundly sculpted youthful effect."
  },
  "fc7": {
    name: "Power Detox Skin For Men",
    duration: "60min",
    description: "A treatment designed for men which will treat their particular skin against the effects of time and dehydration. Using tools such as a steamer to decongest and powerful detoxifying products to revitalize. A moment for them where relaxation, stimulation and microcirculation is favored by foot, skull and face massage sequences."
  },
  "fc8": {
    name: "Fountain of Youth",
    duration: "50min",
    description: "These specific facial treatments will gently but firmly take on the challenges of sensitivity, dehydration, oxidation, and dullness for lighter, healthier complexions. Hyaluronic treatment for all skin types."
  },
  // WAXING
  "wx1": {
    name: "Brows Waxing",
    duration: "15min",
    description: "Traditional bee wax removal that will vigorously remove hair from its anagenic form in a non-invasive way, respecting the anatomy of your hair type, its direction and its biological clock."
  },
  "wx6": {
    name: "Pack Face Waxing",
    duration: "30min",
    description: "Complete face waxing including brows, ears, nostrils, chin - Zone A treatment for a perfectly smooth face."
  },
  "wx15": {
    name: "Full Body Waxing",
    duration: "90min",
    description: "Complete body waxing treatment covering all zones: face, arms, armpits, back, chest, bikini area, and full legs."
  },
};

const ServicesPage = () => {
  const { language, t } = useLanguage();
  const { openBooking } = useBooking();
  const [services, setServices] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState('lashes_brows');
  const [selectedService, setSelectedService] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get(`${API}/services`);
        setServices(response.data);
      } catch (error) {
        console.error('Error fetching services:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, []);

  const beautyCategories = ['lashes_brows', 'makeup', 'facial_care', 'manicure', 'pedicure', 'waxing'];

  const getCategoryLabel = (category) => {
    const labels = categoryLabels[category];
    return labels?.[language] || labels?.en || category;
  };

  const getServiceDetails = (serviceId) => {
    // First try to get from hardcoded details for backwards compatibility
    const hardcoded = SERVICE_DETAILS[serviceId];
    return hardcoded || null;
  };

  // Get localized description from service data
  const getServiceDescription = (service) => {
    if (!service) return null;
    const descKey = `description_${language}`;
    return service[descKey] || service.description_en || service.description || null;
  };

  // Get localized name from service data
  const getServiceName = (service) => {
    if (!service) return '';
    const nameKey = `name_${language}`;
    return service[nameKey] || service.name_en || service.name_pt || '';
  };

  return (
    <div className="min-h-screen bg-kamit-beige pt-20" data-testid="services-page">
      {/* Hero with Salon Image */}
      <section className="relative h-[50vh] min-h-[400px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src={HERO_IMAGE}
            alt="Beauty & Aesthetics"
            className="w-full h-full object-cover"
            style={{ filter: 'brightness(1.1) contrast(1.05)' }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-kamit-dark/60 via-kamit-dark/40 to-kamit-dark/70" />
        </div>
        <div className="relative z-10 text-center px-4">
          <h1 className="font-heading text-5xl md:text-6xl text-kamit-beige mb-4">
            {t('services_title')}
          </h1>
          <p className="text-kamit-beige/80 text-lg max-w-2xl mx-auto">
            {language === 'pt' 
              ? 'Descubra a nossa gama completa de serviços de beleza e estética'
              : language === 'fr'
              ? 'Découvrez notre gamme complète de services de beauté et d\'esthétique'
              : language === 'de'
              ? 'Entdecken Sie unser komplettes Angebot an Schönheits- und Ästhetikdienstleistungen'
              : language === 'es'
              ? 'Descubre nuestra gama completa de servicios de belleza y estética'
              : 'Discover our complete range of beauty and aesthetic services'
            }
          </p>
        </div>
      </section>

      {/* Quick Links */}
      <section className="py-8 bg-kamit-cream border-b border-kamit-brown/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/afro-hair">
              <Button variant="outline" className="border-kamit-brown text-kamit-brown hover:bg-kamit-brown hover:text-kamit-beige rounded-full">
                <Sparkles className="mr-2 h-4 w-4" />
                Afro Hair Studio
              </Button>
            </Link>
            <Link to="/spa-wellness">
              <Button variant="outline" className="border-kamit-brown text-kamit-brown hover:bg-kamit-brown hover:text-kamit-beige rounded-full">
                Spa & Wellness
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Category Cards with Images */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {beautyCategories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`relative overflow-hidden rounded-xl aspect-square group transition-all ${
                  activeCategory === category ? 'ring-4 ring-kamit-gold' : ''
                }`}
              >
                <img 
                  src={CATEGORY_IMAGES[category]}
                  alt={getCategoryLabel(category)}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-kamit-dark/80 via-kamit-dark/30 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <p className={`text-center text-sm font-medium ${
                    activeCategory === category ? 'text-kamit-gold' : 'text-kamit-beige'
                  }`}>
                    {getCategoryLabel(category)}
                  </p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Services List */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl text-kamit-brown mb-2">
              {getCategoryLabel(activeCategory)}
            </h2>
            <div className="w-16 h-1 bg-kamit-gold mx-auto" />
          </div>

          {loading ? (
            <div className="text-center py-12">
              <div className="animate-spin h-8 w-8 border-4 border-kamit-gold border-t-transparent rounded-full mx-auto" />
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {services[activeCategory]?.map((service) => {
                const details = getServiceDetails(service.id);
                return (
                  <div
                    key={service.id}
                    onClick={() => setSelectedService({ ...service, details })}
                    className="bg-white rounded-xl p-6 shadow-sm hover:shadow-lg transition-all border border-kamit-brown/5 cursor-pointer group"
                    data-testid={`service-item-${service.id}`}
                  >
                    <div className="flex justify-between items-start mb-4">
                      <h3 className="font-heading text-xl text-kamit-brown group-hover:text-kamit-gold transition-colors">
                        {getServiceName(service)}
                      </h3>
                      <span className="text-kamit-gold font-semibold text-lg">
                        {service.price}
                      </span>
                    </div>
                    {(service.duration || details?.duration) && (
                      <div className="flex items-center gap-2 text-kamit-brown/60 text-sm">
                        <Clock className="h-4 w-4" />
                        <span>{service.duration || details?.duration}</span>
                      </div>
                    )}
                    <p className="text-kamit-gold/80 text-sm mt-3">
                      {language === 'fr' ? 'Cliquez pour plus de détails' : language === 'pt' ? 'Clique para mais detalhes' : language === 'de' ? 'Klicken Sie für Details' : language === 'es' ? 'Haga clic para más detalles' : 'Click for details'}
                    </p>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>

      {/* Service Detail Modal */}
      <Dialog open={!!selectedService} onOpenChange={() => setSelectedService(null)}>
        <DialogContent className="max-w-lg bg-kamit-beige border-kamit-brown/20 p-0 overflow-hidden">
          <div className="relative">
            {/* Header Image */}
            <div className="h-32 bg-kamit-brown relative">
              <img 
                src={CATEGORY_IMAGES[activeCategory]}
                alt=""
                className="w-full h-full object-cover opacity-50"
              />
              <button
                onClick={() => setSelectedService(null)}
                className="absolute top-4 right-4 p-2 bg-kamit-dark/50 rounded-full text-white hover:bg-kamit-dark"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            
            {/* Content */}
            <div className="p-6">
              <div className="flex justify-between items-start mb-4">
                <h3 className="font-heading text-2xl text-kamit-brown">
                  {getServiceName(selectedService)}
                </h3>
                <span className="text-kamit-gold font-bold text-xl">
                  {selectedService?.price}
                </span>
              </div>
              
              {(selectedService?.duration || selectedService?.details?.duration) && (
                <div className="flex items-center gap-2 text-kamit-brown/70 mb-4">
                  <Clock className="h-5 w-5 text-kamit-gold" />
                  <span className="font-medium">{selectedService?.duration || selectedService.details.duration}</span>
                </div>
              )}
              
              {(getServiceDescription(selectedService) || selectedService?.details?.description) && (
                <p className="text-kamit-brown/80 leading-relaxed mb-6">
                  {getServiceDescription(selectedService) || selectedService.details.description}
                </p>
              )}
              
              <Button 
                onClick={() => {
                  setSelectedService(null);
                  openBooking(activeCategory);
                }}
                className="w-full bg-kamit-gold hover:bg-kamit-gold/90 text-kamit-dark rounded-full"
                data-testid="service-modal-book-btn"
              >
                {language === 'fr' ? 'Réserver maintenant' : language === 'pt' ? 'Reservar agora' : 'Book Now'}
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* CTA */}
      <section className="py-16 bg-kamit-cream">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-3xl text-kamit-brown mb-4">
            {language === 'fr' ? 'Prête à Briller ?' : language === 'pt' ? 'Pronta para Brilhar?' : 'Ready to Shine?'}
          </h2>
          <p className="text-kamit-brown/70 mb-8">
            {language === 'fr'
              ? 'Réservez votre soin beauté aujourd\'hui.'
              : language === 'pt'
              ? 'Marque o seu tratamento de beleza hoje.'
              : 'Book your beauty treatment today.'
            }
          </p>
          <Button 
            onClick={() => openBooking()}
            className="bg-kamit-gold hover:bg-kamit-gold/90 text-kamit-dark rounded-full px-8 py-6 text-lg btn-shine"
            data-testid="services-cta-book-btn"
          >
            {t('nav_book')}
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
